export default __webpack_public_path__ + "static/media/recruit_section_image_2@3x.c1f38391.webp";